import { Controller } from "stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static get targets() {
    return ["capture_ids"];
  }
  initialize() {
    console.log("Tom Select controller initialized");
  }
  connect() {
    const idTextfield = this.capture_idsTarget;
    const select = new TomSelect("#game_mod_tags_visible", {
      maxItems: null,
      valueField: 'id',
      labelField: 'tag',
      searchField: 'tag',
      preload: true,
      // use fetch api to fetch remote data
      load: async (query, callback) => {
        try {
          const res = await fetch("/api/mod_tags");
          const data = await res.json();
          callback(data.options);
        } catch (error) {
          console.error(error);
          callback();
        }
      },
      onItemAdd: (value) => {
        const initialValues = idTextfield.value;
        // if may laman
        if (initialValues !== "") {
          let arr = [initialValues];
          arr.push(value);
          idTextfield.value = arr
          // console.log(idTextfield.value);
        }
        // else
        else {
          let arr = value;
          idTextfield.value = arr
          // console.log(idTextfield.value);
        }
      },
      onItemRemove: (value) => {
        let initialValues = idTextfield.value;
        let arr = initialValues.split(",");
        arr.pop();
        idTextfield.value = arr;
      },
      create: false
    });
    select.on("load", () => {
      const initialValues = idTextfield.value;
      if (initialValues !== "") {
        let arr = initialValues.split(",");
        idTextfield.value = "";
        arr.forEach(async (val, index) => {
          try {
            const res = await fetch(`/api/mod_tags/${val}`);
            const data = await res.json();
            select.addItem(data.options[0].id);
          } catch (error) {
            console.error(error); 
          }
        });
      }
      else {
        console.log("No initial values");
      }
    });
  }
}
